import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';


export const ProductionPlantBasicInfoComponent = ({ onInnerFormChange, selectedProductionPlant, organizationUnits }: any) => (
          <>
 <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'ProductionPlantInfo.Name',
                  selectedProductionPlant?.ProductionPlantInfo
                )
              }}
              type="text"
              value={selectedProductionPlant?.ProductionPlantInfo?.Name}
          />
      <InputContainer
              label="PhoneNumber"
              name="PhoneNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'ProductionPlantInfo.PhoneNumber',
                  selectedProductionPlant?.ProductionPlantInfo
                )
              }}
              type="text"
              value={selectedProductionPlant?.ProductionPlantInfo?.PhoneNumber}
          />
       <InputContainer

              label="IsPrimaryProductionPlant"
              name="IsPrimaryProductionPlant"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'ProductionPlantInfo.IsPrimaryProductionPlant',
                  selectedProductionPlant?.ProductionPlantInfo
                )
              }}
              type="checkbox"
              value={selectedProductionPlant?.ProductionPlantInfo?.IsPrimaryProductionPlant}
          />
     <InputContainer
            label="OrganizationUnit"
            labelField="OrganizationUnitInfo.Name"
            list={organizationUnits}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'ProductionPlantInfo.OrganizationUnitId',
                selectedProductionPlant?.ProductionPlantInfo
              );
            }}
            optionName='Choose OrganizationUnit'
            type="select"
            value={selectedProductionPlant?.ProductionPlantInfo?.OrganizationUnitId}
            valueField="OrganizationUnitInfo.Id"
        />
     </div>
}
expandedPanel="basicInfo"
headerTitle="Basic Info"
/>
</>
)
export default ProductionPlantBasicInfoComponent;
